import pollReducers from './poll';

export default {
  ...pollReducers,
}
